var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index"},[_c('Header'),_c('div',{staticClass:"wrap-block"},[_c('Banner'),_c('IndexService')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }